import React, { useContext } from "react";
import { DesignAssetContext } from "../../pages/CustomHooks/ContextApi";

const Ecc = () => {
  const {
    count,
  } = useContext(DesignAssetContext);
  const getWidthByDerCount = () => {
     let widthPerDer = 500;
     if (count?.derCount === 2 ) {
       widthPerDer = 400;
     }else if(count?.derCount === 3){
      widthPerDer += 0;
     }else if(count?.derCount === 4){
      widthPerDer += 120;
     }else if(count?.derCount === 5){
      widthPerDer += 240;
     }
      return widthPerDer;
  };
  return (
    <>
      { (
        <svg x={"0"}>
          {" "}
          <g id="ECC">
            {" "}
            <svg>
              {" "}
              <g
                id="ECC"
                stroke="none"
                strokeWidth="1"
                fill="none"
                fillRule="evenodd"
              >
                {" "}
                <g id="ECC" transform="translate(-532.000000, -514.000000)">
                  {" "}
                  <g
                    id="SLD/Infos/Microgrid_Background"
                    transform="translate(532.000000, 514.000000)"
                  >
                    {" "}
                    <rect
                      id="Rectangle-Copy-24"
                      stroke="var(--se-sld-circline)"
                      strokeWidth="3"
                      x={"360"}
                      y="269"
                      width={getWidthByDerCount()}
                      height="180"
                      rx="16"
                    />{" "}
                    <text
                      id="AAA"
                      fontFamily="Nunito-Regular, Nunito"
                      fontSize="18"
                      fontWeight="normal"
                      fill="var(--se-sld-circline)"
                    >
                      {" "}
                      <tspan x={  count?.derCount === 2
                          ?450
                          :count?.derCount === 5
                          ?800
                          :count?.derCount === 4
                          ?700
                          :count?.derCount === 3
                          ?500:""} y="440">
                        Low Voltage{" "} Switchboard
                      </tspan>
                     
                    </text>{" "}
                  </g>{" "}
                </g>{" "}
              </g>{" "}
            </svg>{" "}
          </g>{" "}
        </svg>
      )}
    </>
  );
};

export default Ecc;
